export default __webpack_public_path__ + "static/media/i14.a86eb370.jpeg";